export default "__VITE_ASSET__BubUp96o__"